/**
 * @generated SignedSource<<066ba367cb0eea3a4d38bb5c6ba5522a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFilterCBPayAssetsByDestinationWalletsFragment$data = {
  readonly networks: ReadonlyArray<{
    readonly name: string | null;
  } | null> | null;
  readonly symbol: string | null;
  readonly uuid: string | null;
  readonly " $fragmentType": "useFilterCBPayAssetsByDestinationWalletsFragment";
};
export type useFilterCBPayAssetsByDestinationWalletsFragment$key = {
  readonly " $data"?: useFilterCBPayAssetsByDestinationWalletsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFilterCBPayAssetsByDestinationWalletsFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useFilterCBPayAssetsByDestinationWalletsFragment"
};

(node as any).hash = "feb5c18d7e39dcec7edb116221b68be3";

export default node;
